module.exports = __webpack_public_path__ + "img/user.03722dde.svg";